module.exports = __webpack_public_path__ + "img/tips3list6img19120301.0d97ec74.jpg";